<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="title" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="24">
        <div class="form-group">
          <label>Role Name *</label>
          <el-input 
            v-model="formData.caption" 
            placeholder="Enter role name"
            :disabled="!editable">
          </el-input>
        </div>
      </el-col>
    </el-row>

    <div class="action-btns mt-4" v-if="!bindingForView">
      <el-row>
        <el-col :span="24">
          <div class="text-center">
            <el-button @click="cancelForm" icon="el-icon-close" plain>Cancel</el-button>
            <el-button @click="submitForm" icon="el-icon-check" type="primary">
              {{ (!editMode) ? 'Create' : 'Update' }}
            </el-button>
            <el-button @click="removeEntity" icon="el-icon-delete" type="danger" v-if="editMode && moduleDeleteAction">
              Remove
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataToBind: {
      default: null
    },
    bindingForView: {
      type: Boolean,
      default: false
    },
    formHeader: {
      type: Boolean,
      default: false
    },
    formTitle: {
      type: String,
      default: ''
    },
    onCreateCallback: {
      type: Function,
      default: null
    },
    onEditCallback: {
      type: Function,
      default: null
    },
    moduleDeleteAction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      amReady: false,
      module: {
        ...module
      },
      editable: true,
      formData: {
        caption: ''
      }
    }
  },
  computed: {
    getFormTitle() {
      if (this.formTitle) {
        return this.formTitle
      }
      return (this.editMode ? 'Update ' : 'Create ') + this.module.info.caption
    }
  },
  methods: {
    ...mapActions(module.info.name + '-api', {
      createEntity: 'create',
      updateEntity: 'update',
      removeEntity: 'remove'
    }),    submitForm() {
      // Simple validation
      if (!this.formData.caption) {
        notify({
          type: 'error',
          title: 'Role name is required'
        })
        return
      }
      
      // Clean form data to avoid reactivity issues
      const cleanFormData = JSON.parse(JSON.stringify(this.formData))
      
      if (this.editMode) {
        this.updateEntity({
          id: this.dataToBind.id,
          data: cleanFormData
        }).then((response) => {
          if (this.onEditCallback) {
            this.onEditCallback(response.data || response)
          } else {
            notifySuccess('Role updated successfully')
          }
        }).catch(e => {
          notify({
            type: 'error',
            title: 'Error updating role'
          })
        })
      } else {
        this.createEntity({data: cleanFormData}).then((response) => {
          if (this.onCreateCallback) {
            this.onCreateCallback(response.data || response)
          } else {
            notifySuccess('Role created successfully')
          }
          // Reset form
          this.formData = {
            caption: ''
          }
        }).catch(e => {
          notify({
            type: 'error',
            title: 'Error creating role'
          })
        })
      }
    },

    cancelForm() {
      this.$emit('cancel')
    },

    removeEntity() {
      if (this.moduleDeleteAction && this.dataToBind) {
        this.moduleDeleteAction()
      }
    }
  },

  created() {
    if (this.editMode && this.dataToBind) {
      this.formData = {
        caption: this.dataToBind.caption || this.dataToBind.name || ''
      }
    }

    this.amReady = true
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
</style>